<template>
    <div>
      <div class="container-fluid" style="height: 65px">
        <router-link to="/ajouterRetenus">
          <CButton
            style="
              margin-bottom: 7px;
              border-radius: 15px 18px;
              margin-top: -18px;
              margin-left: -8px;
            "
            color="info"
            class="mr-1 cl"
          >
            Nouveau
          </CButton>
        </router-link>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <input
                class="form-control personalise"
                placeholder="Recherche ..."
                type="text"
                v-model="search"
              />
            </div>
          </div>
        </div>
  
        <div class="table-responsive" style="border: 1px solid #f5a623">
          <table class="table table-white">
            <thead>
              <tr>
          
  
                <th scope="col">Raison Sociale</th>
                <th scope="col">date</th>
                <th scope="col">Montant Bruts</th>
  
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in filteredRetenus" v-bind:key="user.id">
                <td>
                  <router-link
                    style="color: #4f5d73"
                    :to="{
                      name: 'show_ajouterRetenus',
                      params: { id: user.id },
                    }"
                  >
                    {{ user.raison_sociale }}
                  </router-link>
                </td>
  
                <!-- <td v-text="user.nom_chouffeur"></td> -->
  
                <td>
                  {{ user.date}}
                  
                </td>

                <td>
                  {{ user.monat_bruts}}
                  
                </td>
  
                <td>
                  <a
                      :href="
                        'https://apil.auto-turki.com/api/retenue/pdf/' +
                        user.id
                      "
                      target="_blank"
                      style="background-color: transparent !important"
                    >
                      <img style="width: 29px" src="imp.png" />
                    </a>
                  
                  <img
                    @click="delete_Retenus(user.id)"
                    style="margin-left: 4px"
                    src="sup.png"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  import { apiDomain } from "../../config";
  import axios from "axios";
  import HighlightWords from "vue-highlight-words";
  
  import Highlighter from "vue-highlight-words";
  export default {
    props: {
      tableHeaderColor: {
        type: String,
        default: "",
      },
    },
    components: {
      Highlighter,
      HighlightWords,
    },
    data() {
      return {
        search: "",
        listes_service: [],
        selected: [],
        get_societe_id_mise: {},
        verif: false,
        selectedOptionId: "",
        moezMois: [
          { id: 1, text: "Janvier" },
          { id: 2, text: "Février" },
  
          { id: 3, text: "Mars" },
          { id: 4, text: "Avril" },
          { id: 5, text: "Mai" },
          { id: 6, text: "Juin" },
  
          { id: 7, text: "Juillet" },
          { id: 8, text: "Août" },
  
          { id: 9, text: "Septembre" },
          { id: 10, text: "Octobre" },
          { id: 11, text: "Novembre" },
          { id: 12, text: "Décembre" },
        ],
        moezAnnee: [
          { id: 2020, text: "2020" },
          { id: 2021, text: "2021" },
          { id: 2022, text: "2022" },
  
          { id: 2023, text: "2023" },
          { id: 2024, text: "2024" },
          { id: 2025, text: "2025" },
          { id: 2026, text: "2026" },
  
          { id: 2027, text: "2027" },
          { id: 2028, text: "2028" },
        ],
        anneeUsers: [2020, 2021, 2022, 2024],
        moisUsers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  
        yearSystem: new Date().getFullYear(),
        moisSystem: new Date().getMonth() + 1,
        selectedMois: {
          Month: new Date().getMonth() + 1,
        },
  
        selectedClient: {
          year: new Date().getFullYear(),
        },
        listes_service: [],
        selected: [],
        q: "",
        /* ******************************* */
        totalTraitementAnnee_v: "",
        listes_Retenus: [],
        count_service: "",
      };
    },
  
    created() {
      //this.fetchListesTypes();
      this.fetchsearch();
      this.loadRetenus();
    },
  
    computed: {
      filteredRetenus: function () {
        if (Array.isArray(this.listes_Retenus)) {
          return this.listes_Retenus.filter((retenue) => {
            return (
              retenue.raison_sociale.match(this.search) || retenue.date.match(this.search)
            );
          });
        }
      },
    },
  
    methods: {
      delete_Retenus(id) {
        if (confirm("Azouz SVP Vérifier Sure ?")) {
        fetch(`${apiDomain}/api/retenue/${id}`, {
          method: "delete",
        })
          .then((res) => res.json())
          .then((data) => {
            this.$noty.success("Retenue supprimer avec Succès ! ");
            this.loadRetenus();
          })
  
          .catch((err) => console.log(err));
        }
      },
      /* new azouz 2021 */
      keywords() {
        return this.search.split(" ");
      },
  
      loadRetenus() {
        axios
          .get(`${apiDomain}/api/retenue`)
          .then((response) => {
            this.listes_Retenus = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
  
      /* fin new 2022 */
      fetchsearch() {
        if (this.q.length > 1) {
          axios
            .get(`${apiDomain}/api/Listes_services_ajouter/` + this.q)
            .then((res) => (this.listes_service = res.data))
            .catch((error) => console.log(error));
        } else {
          axios
            .get(`${apiDomain}/api/Listes_services_ajouter`)
            .then((res) => (this.listes_service = res.data))
            .catch((error) => console.log(error));
        }
      },
      /*  delete_service(id) {
        fetch(`${apiDomain}/api/delete_service/${id}`, {
          method: 'delete',
        })
          .then((res) => res.json())
          .then((data) => {
            this.$noty.success('Service  supprimer avec Succès ! ')
  
            this.fetchsearch()
          })
  
          .catch((err) => console.log(err))
      }, */
      /*   fetchListesTypes() {
        fetch(`${apiDomain}/api/Listes_services_ajouter`)
          .then((res) => res.json())
          .then((res) => {
            this.listes_service = res.all_service.data;
          })
          .catch((err) => console.log(err));
      }, */
    },
  };
  </script>
  
  <style>
  .feed {
    background: #fff;
    height: 106px;
    overflow: scroll;
  }
  .btdelete {
    padding: 11px 27px !important;
    margin-top: 38px;
    border-radius: 5px;
  }
  /* 
  .md-card img {
    width: 55% !important;
    height: auto;
  } */
  </style>
  
  